import { Dispatch, SetStateAction, useEffect, useState } from 'react'

export type Position = {
  sx: number
  sy: number
  sw: number
  sh: number
}

function createCanvasContext(): CanvasRenderingContext2D {
  const canvas: HTMLCanvasElement = document.createElement('canvas')
  const ctx = canvas.getContext('2d')

  if (!ctx) {
    throw new Error("Can't create canvas")
  }

  return ctx
}

function pickColorFromImageBitmap(bitmap: ImageBitmap, row: number, col: number): string {
  const ctx: CanvasRenderingContext2D = createCanvasContext()
  ctx.drawImage(bitmap, 0, 0)

  // RGBA array, element value in [0, 255]
  const imageData: ImageData = ctx.getImageData(0, 0, bitmap.width, bitmap.height, { colorSpace: 'srgb' })

  // nthPixel begins with 0
  const nthPixel = row * bitmap.width + col

  // pick first rgba
  const rgba: Uint8ClampedArray = imageData.data.slice(nthPixel * 4, nthPixel * 4 + 4)

  const rgbaValueIter = rgba.values()
  const rgbaValueArr = Array.from(rgbaValueIter)

  const colorCellValue = (rgbaValueArr[0] + rgbaValueArr[1] + rgbaValueArr[2]) / 3

  return 'rgba(0,0,0,.9)'
}

export function useImageColor(
  imgSrc: string,
  pos: Position,
  initColor: string = 'rgba(0,0,0,.9)'
): [string, Dispatch<SetStateAction<string>>] {
  const [imageSrc, setImageSrc] = useState(imgSrc)
  const [position, setPosition] = useState(pos)

  const [color, setColor] = useState<string>(initColor)

  useEffect(() => {
    const img = new Image()
    img.loading = 'lazy'
    img.onload = function () {
      createImageBitmap(img, pos.sx, pos.sy, pos.sw, pos.sh).then((bitmap: ImageBitmap) => {
        console.log('UseImageColor.bitmap: ', bitmap)
        console.log('UseImageColor.pickColor:', pickColorFromImageBitmap(bitmap, 0, 0))

        setColor(pickColorFromImageBitmap(bitmap, 0, 0))
      })
    }

    img.src = imageSrc
  }, [imageSrc, position])

  return [color, setImageSrc]
}
